// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__16z-q","list":"styles_list__1LErq"};